import { useProductVariants } from '@jetshop/core/hooks/useProductVariants';
import { useVariantFromUrl } from '@jetshop/core/hooks/useProductVariants/useVariantFromUrl';
import getParentOrCanonicalRoute from '@jetshop/ui/Breadcrumbs/getParentsOrCanonicalRoute';
import { styled } from 'linaria/react';
import React from 'react';
import { ContentPadding } from '../Layout/Content/Content';
import MaxWidth from '../Layout/MaxWidth';
import { theme } from '../Theming/Theming';
import CustomData from './CustomData';
import ImageSlider from './ImageSlider/ImageSlider';
import ProductDetails from './ProductDetails';
import ProductTabs from './ProductTabs/ProductTabs';
import RelatedProductsAddon from './RelatedProductsAddon/RelatedProductsAddon';
import Releware from './Releware';
import AddwishContainerPdp from './AddwishContainerPdp';

const ProductPageContainer = styled(MaxWidth)`
  display: flex;
  align-items: center;
  flex-direction: column;
  ${theme.above.md} {
    padding-top: 1rem;
  }
  ${ContentPadding}
`;

const ProductContainer = styled('div')`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  ${theme.below.lg} {
  }
`;

export const Section = styled('section')`
  width: 100%;
  ${theme.only.md} {
    padding-bottom: 1rem;
    &.product-images-wrapper {
      width: 45%;
    }
    &.product-info-wrapper {
      width: 50%;
    }
  }
  ${theme.above.lg} {
    padding-bottom: 2rem;
    &.product-images-wrapper {
      width: 48%;
    }
    &.product-info-wrapper {
      width: 48%;
    }
  }
  ${theme.below.sm} {
    &.product-images-wrapper {
      margin-left: -${theme.general.pagePadding.sm};
      width: 100vw;
      .main-slider {
        width: 100vw;
      }
    }
  }
`;

export const SectionHeading = styled('h2')`
  font-size: 1.2rem;
  margin-bottom: 1rem;
`;

const ProductTabsWrapper = styled('div')`
  margin-top: 1rem;
  width: 100%;
  ${theme.above.md} {
    //width: 50%;
  }
`;

const Product = ({ result: { data, loading }, product, partialProduct }) => {
  //PARTIAL PRODUCT FORM CATEGORY
  if (!product) {
    product = partialProduct;
  }

  const initialVariant = useVariantFromUrl();

  //GET VARIANTS HANDLING
  const variantHandler = useProductVariants(
    product && product.articleNumber ? product : undefined,
    { initialVariant }
  );

  //console.log(addWishResponseBoxItems);

  //NULL CHECK
  if (!product) {
    return null;
  }

  //VARIANTS VARIABLES
  const { selectedVariant: selectedVariation } = variantHandler;

  //CUSTOM FIX TO SHOW VARIANT IMAGE WHEN JUST COLOR IS SELECTED
  const variantImageSlider =
    selectedVariation ||
    (variantHandler.missingOptions?.length === 1 &&
      variantHandler.getVariantForSelection(
        variantHandler.missingOptions[0].values[0],
        variantHandler.missingOptions[0]
      ));

  //BREADCRUMBS
  const parents = getParentOrCanonicalRoute(data?.route?.parents, product);
  const breadcrumbProps = {
    breadcrumbs: data?.route?.breadcrumbs,
    parents
  };

  return (
    <ProductPageContainer>
      <ProductContainer>
        <CustomData product={product}>
          {(customFields, customTabs, customData) => (
            <>
              <Section className="product-images-wrapper">
                <ImageSlider
                  product={product}
                  customData={customData}
                  selectedVariation={variantImageSlider}
                />
              </Section>
              <Section className="product-info-wrapper">
                <ProductDetails
                  {...{
                    product,
                    selectedVariation,
                    variantHandler,
                    breadcrumbProps
                  }}
                />
              </Section>
              <ProductTabsWrapper>
                <ProductTabs
                  product={product}
                  customFields={customFields}
                  customTabs={customTabs}
                  loading={loading}
                />
              </ProductTabsWrapper>
              {product.relatedProducts &&
                product.relatedProducts.length > 0 && (
                  <RelatedProductsAddon products={product.relatedProducts} />
                )}
            </>
          )}
        </CustomData>

        <AddwishContainerPdp product={product} breadcrumbs={data?.route?.breadcrumbs}/>

        {product.recommendedProducts && (
          <>
            {product.recommendedProducts.shuffledToplist.length > 0 && (
              <Releware
                products={product.recommendedProducts.shuffledToplist}
                title={'Popular products'}
              />
            )}
            {product.recommendedProducts.viewed.length > 0 && (
              <Releware
                products={product.recommendedProducts.viewed}
                title={'Others also looked at'}
              />
            )}
            {product.recommendedProducts.bought.length > 0 && (
              <Releware
                products={product.recommendedProducts.bought}
                title={'Others also bought'}
              />
            )}
          </>
        )}
      </ProductContainer>
    </ProductPageContainer>
  );
};



export default Product;
